export default [
  {
    title: 'Oferta académica',
    route: 'oferta-academica',
    icon: 'GridIcon',
  },
]
